export const manualQualifySteps = Object.freeze({
    Welcome: 'welcome',
    ManualSelection: 'manual_selection',
    ManualMessaging: 'manual_messaging',
});

export const DEFAULT_MANUAL_QUALIFY_LOW_TALENT_THRESHOLD = 300;
